export default __webpack_public_path__ + "static/media/datafarming-terms-and-condition.8d198b21.pdf";